import React from 'react'

const Donate1 = () => {
    const community = {
        title: "Afrika Community",
        location: "Nyika, Country",
        farmerCount: "12,001",
        category: "Fruits & Vegetables",
        code: "FNKEFA123456",
        rating: "4.3",
        reviews: "653",
    };
    
    return (
        <div className='bg-white'>
            <div className='md:px-24 px-4 md:pt-8 pt-3'>
                <div>
                    <div className="flex justify-between items-center mb-2 md:mb-4">
                        <a href='/Communities'>
                            <h1 className="text-[#FDBD26] font-bold text-[12px] md:text-[36px]">Communities</h1>
                        </a>
                        <h1 className="text-black font-normal text-[10px] md:text-[36px]">{community.code}</h1>
                    </div>
                    <h1 className="font-bold text-[10px] md:text-[36px] mt-2 mb-1 md:mt-10">
                        Donate
                    </h1>
                    <div className="text-[8px] md:text-[36px] md:leading-8 md:mt-0 -mt-1">
                        <p>Support a farmer through your donations. Thank you.</p>
                    </div>


                    <h1 className="font-bold text-[10px] md:text-[34px] mt-4 md:mt-14 text-center mb-2 mr-8">Choose amount</h1>
                    <h1 className="font-bold text-[8px] md:text-[34px] md:leading-relaxed mb-2 md:mt-4">How much would you like to donate?</h1>

                    <div className="text-[8px] md:text-[37px] mb-2 md:leading-10">
                        <p>
                            As a contributor to supporting the developments of farmers communities, we make sure that you donation goes
                            directly in supporting our course.
                        </p>
                        <p>Thank you for your support.</p>
                    </div>
                    {/* Donation buttons */}
                    <div className="grid grid-cols-5 sm:grid-cols-5 md:grid-cols-5 md:gap-4 gap-1 mt-4 md:mt-20 text-[10px] md:text-[48px] font-bold">
                        <button className="h-[40px] md:h-[105px] rounded-md bg-[#9FAFAF] text-white">
                            USD5
                        </button>
                        <button className="h-[40px] md:h-[105px] rounded-md bg-[#9FAFAF] text-white">
                            USD10
                        </button>
                        <button className="h-[40px] md:h-[105px] rounded-md bg-[#9FAFAF] text-white sm:col-span-1 md:col-span-1">
                            USD20
                        </button>
                        <button className="h-[40px] md:h-[105px] rounded-md bg-[#9FAFAF] text-white sm:col-span-1 md:col-span-1">
                            USD50
                        </button>
                        <button className="h-[40px] md:h-[105px] rounded-md bg-[#9FAFAF] text-white text-[8px] md:text-[24px] md:col-span-1">
                        Customise your donation
                        </button>
                    </div>
                    <h1 className="font-bold text-[10px] md:text-[34px] md:leading-relaxed mb-2 md:mt-10 mt-6">Bank Details.</h1>
                    <div className='md:h-[5px] bg-[#D9D9D9] w-full md:mb-3'></div>

                    <div className="space-y-3 md:mt-5 md:mb-5">
  <div className="flex lg:flex-row items-center justify-between w-full lg:h-[114px] rounded-lg bg-[#FAFBFB] py-2 md:py-0">
    <h1 className="mb-1 md:mb-0 font-bold text-[10px] lg:text-[36px] lg:pl-8 pl-2">
      Farmers Networks App
    </h1>
    <input
      type="text"
      defaultValue="Bank Details"
      className="flex items-center md:pl-5 pl-2 md:w-[90vh] border-[#FAFBFB] w-[30vh] h-[40px] lg:h-[114px] rounded-lg bg-[#F3F5F5] text-[10px] lg:text-[36px] font-semibold md:font-bold text-gray-800 focus:outline-none"
    />
  </div>

  <div className="flex lg:flex-row items-center justify-between lg:w-full lg:h-[114px] rounded-lg bg-[#FAFBFB] py-2 md:py-0">
    <h1 className="mb-1 md:mb-0 font-bold text-[10px] lg:text-[36px] lg:pl-8 pl-2">
      Account Number
    </h1>
    <input
      type="text"
      defaultValue="2046261758"
      className="flex items-center md:pl-5 pl-2 border-[#FAFBFB] md:w-[90vh] w-[30vh] h-[40px] lg:h-[114px] rounded-lg bg-[#F3F5F5] text-[10px] lg:text-[36px] font-semibold md:font-bold text-gray-800 focus:outline-none"
    />
  </div>

  <div className="flex lg:flex-row items-center justify-between lg:w-full lg:h-[114px] rounded-lg bg-[#FAFBFB] py-2 md:py-0">
    <h1 className="mb-1 md:mb-0 font-bold text-[10px] lg:text-[36px] lg:pl-8 pl-2">
      BRANCH CODE
    </h1>
    <input
      type="text"
      defaultValue="90"
      className="flex items-center md:pl-5 pl-2 border-[#FAFBFB] md:w-[90vh] w-[30vh] h-[40px] lg:h-[114px] rounded-lg bg-[#F3F5F5] text-[10px] lg:text-[36px] font-semibold md:font-bold text-gray-800 focus:outline-none"
    />
  </div>

  <div className="flex lg:flex-row items-center justify-between lg:w-full lg:h-[114px] rounded-lg bg-[#FAFBFB] py-2 md:py-0">
    <h1 className="mb-1 md:mb-0 font-bold text-[10px] lg:text-[36px] lg:pl-8 pl-2">
      SWIFT CODE
    </h1>
    <input
      type="text"
      defaultValue="BARCKENX"
      className="flex items-center md:pl-5 pl-2 border-[#FAFBFB] md:w-[90vh] w-[30vh] h-[40px] lg:h-[114px] rounded-lg bg-[#F3F5F5] text-[10px] lg:text-[36px] font-semibold md:font-bold text-gray-800 focus:outline-none"
    />
  </div>
</div>

                    <p className=" text-[10px] font-bold md:text-[37px] mt-8 mb-4 md:mt-20 md:leading-10 ">Please confirm the amount you are donating.</p>

                    <div className="space-y-3 mt-4">
  {/* Payment Amount */}
  <div className="flex lg:flex-row items-center justify-between lg:w-full lg:h-[114px] border border-[#919291] rounded-sm bg-[#FAFBFB] md:py-0">
    <input
      type="text"
      defaultValue="Payment amount"
      className="text-[10px] lg:text-[36px] font-normal lg:pl-12 pl-2 flex-1 bg-transparent outline-none placeholder:text-black h-full"
    />
    <h1 className="flex items-center justify-center w-[28vh] lg:w-[328px] h-full border-2 border-[#919291] rounded-sm bg-[#F3F5F5] text-[10px] lg:text-[36px] font-semibold md:font-bold text-gray-800">
      USD 100
    </h1>
  </div>

  {/* Frequency */}
  <div className="flex lg:flex-row items-center justify-between lg:w-full lg:h-[114px] border border-[#919291] rounded-sm bg-[#FAFBFB] md:py-0">
    <input
      type="text"
      defaultValue="Frequency"
      className="text-[10px] lg:text-[36px] font-normal lg:pl-12 pl-2 flex-1 bg-transparent outline-none placeholder:text-black h-full"
    />
    <h1 className="flex items-center justify-center w-[28vh] lg:w-[328px] h-full border-2 border-[#919291] rounded-sm bg-[#F3F5F5] text-[10px] lg:text-[36px] font-semibold md:font-bold text-gray-800">
      One time
    </h1>
  </div>

  {/* Donation Total */}
  <div className="flex lg:flex-row items-center justify-between lg:w-full lg:h-[114px] border border-[#919291] rounded-sm bg-[#FAFBFB] md:py-0">
    <input
      type="text"
      defaultValue="Donation Total"
      className="text-[10px] lg:text-[36px] font-semibold lg:pl-12 pl-2 flex-1 bg-transparent outline-none placeholder:text-black h-full"
    />
    <h1 className="flex items-center justify-center w-[28vh] lg:w-[328px] h-full border-2 border-[#919291] rounded-sm bg-[#F3F5F5] text-[10px] lg:text-[36px] font-semibold md:font-bold text-gray-800">
      USD 100
    </h1>
  </div>
</div>


                    <p className=" text-[10px] md:text-[37px] mt-10 md:mt-16 md:leading-10 font-bold text-center">Thank you for donating to support a farmer.</p>
                    <a href='/Donate1'>
                        <div className="flex md:mt-14 md:px-24 mt-6">

                            <button className="md:text-[48px] text-[16px] font-bold border-b-[5px] border-[#FDBD26] rounded-lg w-full md:h-[100px] h-[60px] px-3 flex items-center justify-center bg-[#152C24] text-white">
                                Donate
                            </button>

                        </div>
                    </a>
                    <div className="flex justify-between items-start md:mt-40 mt-6">
                        <div></div> {/* Empty div to push the button to the right */}

                        <div>
                            <div className="flex items-center ml-auto pr-3 md:pr-0 md:mb-1">
                                <p className="md:text-[16px] text-[10px] bg-[#FFBD26] text-white px-2 md:px-4 md:w-[255px] md:py-[9px] py-[5px] md:rounded-tl-xl rounded-tl-md font-bold md:rounded-bl-xl rounded-bl-md whitespace-nowrap">
                                    CONTACT ADMIN
                                </p>
                                <img
                                    src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744139834/Expand_right_2_a4wodr.png"
                                    alt="Expand"
                                    className="w-[20px] h-[10px] md:h-[42px] md:w-[55px] hidden md:flex object-contain md:rounded-tr-xl rounded-tr-md font-bold md:rounded-br-xl bg-[#152C24] px-2 md:py-2"
                                />
                                <img
                                    src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744370865/Expand_right_5_l2cjmf.png"
                                    alt="Expand"
                                    className="w-[20px] h-[22px] md:hidden flex py-[1px] md:h-[42.3px] md:w-[57px] object-contain md:rounded-tr-xl rounded-tr-md font-bold md:rounded-br-xl rounded-br-md bg-[#152C24] md:px-2 px-[2px] md:py-1"
                                />
                            </div>
                            <p className='md:text-[10px] text-[6px] font-normal md:mt-0 mt-1 text-left'>Contact administrator for more information</p>
                        </div>
                    </div>
                    <div className='md:h-32 h-6'></div>
                </div>
            </div>
        </div>
    )
}

export default Donate1